// extracted by mini-css-extract-plugin
export default {"container":"Home_container__TdHRF","comp_box":"Home_comp_box__7mlY3","is_valid":"Home_is_valid__Qg-ha","app_name":"Home_app_name__KhC8a"};